module.exports = __webpack_public_path__ + "img/marker_aparcament.edb06fea.svg";